module.exports = __webpack_public_path__ + "static/media/road trip.30284693.png";